import React, { useEffect, useRef, useState } from "react";
import styles from "./battleAndBuild.module.css";
import { ReactComponent as TopBackground } from "../../assets/img/battleAndBuild/topBackground.svg";
import { ReactComponent as TopBackgroundSmall } from "../../assets/img/battleAndBuild/topBackgroundSmall.svg";
import { ReactComponent as GameModesTop } from "../../assets/img/battleAndBuild/gameModesTop.svg";
import { ReactComponent as CreatorToolsTop } from "../../assets/img/battleAndBuild/gameModesTop.svg";
import { ReactComponent as CreatorToolsTopSvg1 } from "../../assets/img/battleAndBuild/creatorToolsTop1.svg";
import { ReactComponent as CreatorToolsTopSvg2 } from "../../assets/img/battleAndBuild/creatorToolsTop2.svg";
import { ReactComponent as CreatorToolsTopSvg3 } from "../../assets/img/battleAndBuild/creatorToolsTop3.svg";
import { ReactComponent as CreatorToolsTopSvg4 } from "../../assets/img/battleAndBuild/creatorToolsTop4.svg";
import { ReactComponent as CreatorToolsTopSvg5 } from "../../assets/img/battleAndBuild/creatorToolsTop5.svg";
import { ReactComponent as OwnMechLandLine } from "../../assets/img/battleAndBuild/ownMechLandLine.svg";
import { ReactComponent as OwnMechLandLineSmall } from "../../assets/img/battleAndBuild/ownMechLandLineSmall.svg";
import { ReactComponent as Plus } from "../../assets/img/battleAndBuild/plus.svg";
import { ReactComponent as MakeYourOwnGameSvg } from "../../assets/img/battleAndBuild/makeYourOwnGame.svg";
import { ReactComponent as MakeYourOwnGameSmallSvg } from "../../assets/img/battleAndBuild/makeYourOwnGameSmall.svg";
import VideoMask1 from "../../assets/img/battleAndBuild/VideoMask1.jpg";
import VideoMask2 from "../../assets/img/battleAndBuild/VideoMask2.jpg";
import VideoMask3 from "../../assets/img/battleAndBuild/VideoMask3.jpg";
import makeYourOwnGameImg from "../../assets/img/battleAndBuild/makeYourOwnGameImg.png";

import OwnLandBackgroundImage from "../../assets/img/battleAndBuild/ownLandBackgroundImage.png";

import game1 from "../../assets/img/battleAndBuild/game1.jpg";
import game2 from "../../assets/img/battleAndBuild/game2.jpg";
import game3 from "../../assets/img/battleAndBuild/game3.jpg";

import videoBG from "../../assets/img/battleAndBuild/videoBG.mp4";
import videoBGsmall from "../../assets/img/battleAndBuild/videoBGsmall.mp4";

import Button from "../UI/Button";

const BattleAndGuild = ({}) => {
  const [iframeHeight, setIframeHeight] = useState(252);
  const creatorToolsImgItem = useRef(null);

  const resizeHandler = () => {
    setIframeHeight(
      creatorToolsImgItem.current.getBoundingClientRect().width * 0.562
    );
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    window.addEventListener("resize", resizeHandler);
    resizeHandler();
    return () => {
      window.removeEventListener("resize", resizeHandler);
    };
  }, []);
  return (
    <div className={styles.container}>
      <div className={styles.playAndEarnTop}>
        <video
          src={videoBG}
          className={styles.videoBg}
          autoPlay
          muted
          loop
          controls={false}
          playsinline=""
          preload="auto"
        ></video>
        <video
          src={videoBGsmall}
          className={styles.videoBgSmall}
          autoPlay
          muted
          loop
          controls={false}
          playsinline=""
          preload="auto"
        ></video>
        <TopBackground className={styles.topBackgroundSvg} />
        <TopBackgroundSmall className={styles.topBackgroundSmallSvg} />
        <div className={styles.collectMechNFTsInfoBlock}>
          <h2 className={styles.collectMechNFTsInfoBlockHeader}>
            DIGITAL COLLECTIBLE MECH AVATARS
          </h2>
          <div className={styles.collectMechNFTsInfoBlockText}>
            Choose a Mech from one of the five Elite Mech Classes to join you on
            your journey to Mech domination and go into battle against other
            players.
            <br />
            <br />
            Every single Mech is completely unique and generated by our AI.
            <div className={styles.collectMechNFTsInfoBlockTextTopLine} />
          </div>
          <Button
            click={() => {
              window.open("https://opensea.io/collection/mech-nfts");
            }}
          >
            Explore Mech Collection
          </Button>
        </div>
      </div>
      <div className={styles.gameModesBlockWrapper}>
        <div className={styles.gameModesBlock}>
          <GameModesTop className={styles.gameModesTopSvg} />
          <div className={styles.gameModesInfoBlock}>
            <h2>GAME MODES</h2>
            <h3>Every Mech Can Participate In All Games</h3>
            <div>
              Every Mech generated by our AI comes with a specific class, type
              and faction as well as special abilities and powers which can
              impact the type of gameplay you join. Is your Mech better suited
              to go to war with other Mechs like a gladiator in an arena, or
              will it get its glory using its speed and agility? Explore
              countless game modes and find out!
            </div>
          </div>
          <div className={styles.gamesBlock}>
            <div className={styles.gamesBlockItem}>
              <img src={game1} alt="game image" />
              <h2>Match 3 Series</h2>
              <div>
                For all the casual mobile gamers out there, the Match 3 Series
                will provide hours of fun with its exciting and addictive
                gameplay and allow you to earn Ore while conquering competitive
                levels.
              </div>
            </div>
            <div className={styles.gamesBlockItem}>
              <img src={game2} alt="game image" />
              <h2>Battle Royale Series</h2>
              <div>
                Jump into glorious battles in our Battle Royale Series, where
                you'll be pitted against other mechs in a winner-takes-all
                battle for supremacy. It's every mech for itself in this
                no-holds-barred, metal-crunching showdown.
              </div>
            </div>
            <div className={styles.gamesBlockItem}>
              <img src={game3} alt="game image" />
              <h2>Drift Racing Series</h2>
              <div>
                And if speed and adrenaline are what you're after, then rev up
                for the Drift Racing Series, where you can race against other
                mechs in a high-octane, high-speed race that'll have you feeling
                like a real speed demon.
              </div>
            </div>
          </div>
          <div className={styles.moreGames}>More games coming soon...</div>
        </div>
      </div>
      <div className={styles.ownMechLandWrapper}>
        <img
          src={OwnLandBackgroundImage}
          alt="Bottom Background Image"
          className={styles.ownLandBackgroundImage}
        />
        <div className={styles.ownMechLandInner}>
          <h2>OWN MECH LAND</h2>
          <OwnMechLandLine className={styles.ownMechLandLineSvg} />
          <OwnMechLandLineSmall className={styles.ownMechLandLineSmallSvg} />

          <h3>Become a Mech Citizen</h3>
          <div>
            By becoming a landowner in Mech, you get exclusive access to our
            Creator Tools. Design and build your own slice of paradise with
            custom garages to show off your prized Mechs or create mini-game
            battle arenas to assert your dominance. It's time to join the
            revolution of AI-powered gaming and start building the Mech universe
            of your dreams!
          </div>
          <Button
            click={() => {
              window.open(
                "https://opensea.io/collection/mech-com-land-collection"
              );
            }}
          >
            Become a Mech Citizen
          </Button>
        </div>
        <div className={styles.ownMechLandPlusBlock}>
          <div>
            <Plus /> Rent out Mechs from your custom garages to other players
            and turn a profit. They'll be lining up to get a glimpse of your
            impressive Mech collection.
          </div>
          <div>
            <Plus /> Get creative and craft unique weapons and parts to enhance
            your Mechs. Sell them as NFTs to fellow players and watch the demand
            for your creations soar.
          </div>
          <div>
            <Plus /> Host your own Mech battles and show off your strategic
            prowess in mini-game battle arenas. Design the arena of your dreams
            and watch as other players flock to your land to take on your
            challenges.
          </div>
        </div>
      </div>
      <div className={styles.creatorToolsBlock}>
        <CreatorToolsTop className={styles.creatorToolsSvgTop} />
        <div className={styles.creatorToolsImgTopBlock}>
          <CreatorToolsTopSvg1 />
          <CreatorToolsTopSvg2 />
          <CreatorToolsTopSvg3 />
          <CreatorToolsTopSvg4 />
          <CreatorToolsTopSvg5 />
        </div>
        <div className={styles.creatorToolsInnerBlock}>
          <h2>THE CREATOR TOOLS</h2>
          <h3>LET'S BUILD THE MECH UNIVERSE TOGETHER</h3>
          <div>
            At Mech, we believe in building, growing and monetizing your own
            experience, which is why we've made the Creator Tools that let you
            build amazing assets that the whole community can enjoy! With just a
            few clicks, you can turn your piece of land into Mech’s next hot
            spot. Create your own games, battle arenas, in-game weapon shops, or
            other fun experiences with our AI tools! The power is in your hands!
          </div>
        </div>
        <div className={styles.creatorToolsVideoBlock}>
          <div className={styles.creatorToolsVideoItem}>
            <img
              src={VideoMask1}
              alt="video mask"
              ref={creatorToolsImgItem}
              onLoad={() => {
                setIframeHeight(
                  creatorToolsImgItem.current.getBoundingClientRect().width *
                    0.562
                );
              }}
            />
            <iframe
              src="https://fast.wistia.net/embed/iframe/fd29onk9eg?videoFoam=true"
              height={`${iframeHeight}px`}
            ></iframe>
            <h2>Terraform Your Land</h2>
            <div>
              Our terraform tool lets you turn your land into a masterpiece,
              with rivers, paths, mountains, trees, and more. With the power of
              AI, the possibilities are endless. Want to create a mountain
              protecting your land from the enemy? Or a river that flows around
              your city? The choice is yours!
            </div>
          </div>
          <div className={styles.creatorToolsVideoItem}>
            <img src={VideoMask2} alt="video mask" />
            <iframe
              src=" https://fast.wistia.net/embed/iframe/r97r1erheu?videoFoam=true"
              height={`${iframeHeight}px`}
            ></iframe>
            <h2>Create NFT Buildings</h2>
            <div>
              In Mech, you can design and build buildings with just a few
              clicks. Whether it's a fight arena, a garage for renting out
              Mechs, or something completely wild and wacky, you can make it
              your own. And with our procedural expansion AI tools, you can make
              your creations even more unique and creative without any tech
              skills at all.
            </div>
          </div>
          <div className={styles.creatorToolsVideoItem}>
            <img src={VideoMask3} alt="video mask" />
            <iframe
              height={`${iframeHeight}px`}
              src="https://fast.wistia.net/embed/iframe/eyezlwyg4j?videoFoam=true"
            ></iframe>
            <h2>Design In-Game Assets</h2>
            <div>
              Looking to build your own fortune? With Mech, you can build and
              design unique assets like weapons or even Mech parts that can be
              used, traded, or sold as actual NFTs inside the Mech ecosystem.
              Create something truly one-of-a-kind, and watch as it becomes the
              envy of the Mech universe.
            </div>
          </div>
        </div>
      </div>
      <div className={styles.makeYourOwnGame}>
        <MakeYourOwnGameSvg className={styles.makeYourOwnGameSvg} />
        <MakeYourOwnGameSmallSvg className={styles.makeYourOwnGameSmallSvg} />
        <div className={styles.makeYourOwnGameInner}>
          <h2>
            MAKE (AND MONETIZE) YOUR OWN GAME!
            <div className={styles.makeYourOwnGameInnerLine} />
          </h2>
          <div>
            In addition to our revolutionary battling and customization
            features, Mech.com offers you the unique opportunity to purchase
            large land lots and create your own video games. With complete
            creative control, you can design and monetize your own games,
            limited only by your imagination. Whether you’re an avid gamer or
            aspiring game developer, Mech.com provides the perfect platform to
            explore new worlds, engage in epic battles, and unleash your
            creativity. Join our community today and discover all that our
            cutting-edge AI technology has to offer.
          </div>
          <img
            src={makeYourOwnGameImg}
            className={styles.makeYourOwnGameImg}
            alt="mech img"
          />
        </div>
      </div>
    </div>
  );
};

export default BattleAndGuild;
